export const useIIFE = (callback) => {
    return iife(callback);
};
const iife = (callback) => typeof callback === 'function' && callback();
